import { render, staticRenderFns } from "./DashboardPolicyRenewal.vue?vue&type=template&id=71623f2e&scoped=true"
import script from "./DashboardPolicyRenewal.vue?vue&type=script&lang=js"
export * from "./DashboardPolicyRenewal.vue?vue&type=script&lang=js"
import style0 from "./DashboardPolicyRenewal.vue?vue&type=style&index=0&id=71623f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71623f2e",
  null
  
)

export default component.exports